// extracted by mini-css-extract-plugin
export default {"myBoxMain":"HomePageLayout_myBoxMain__0+Dsb"};